import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterPlayersReportView.
 * @extends JetView
 */
export default class FilterPlayersReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            // Default date range value
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            // Label with icon
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Client ID input
                            name: 'clientId',
                            label: "<span class='icon-id'></span>" + _('ID Cliente'),
                            labelPosition: 'top',
                            placeholder: _('ID Cliente'), // Placeholder text
                            invalidMessage: _('Client ID is required'), // Validation message
                        },
                        { id: 'grav2', gravity: 1 }, // Spacer
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 150 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const buttons = {
            // Button section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        // Clear form values on click
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Trigger filter event on click
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('playersReport:filter', [
                            filterdata, // Pass values to event
                        ]);
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                // Validation rules
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when webix is ready
            if (screen.width < 500) {
                // Hide element based on screen width
                $$('grav2').hide();
            }
        });
    }
}

// FILE DOCUMENTED
